import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChannelHeader = ({ channelData, isSubscribed, onSubscribe, onNotificationToggle }) => {
  return (
    <div className="channel-header bg-card border-b border-border">
      <div className="header-content max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col lg:flex-row gap-6 items-start lg:items-center">
          <div className="channel-avatar flex-shrink-0">
            <div className="w-32 h-32 rounded-full overflow-hidden bg-muted shadow-soft">
              <Image 
                src={channelData?.avatar} 
                alt={channelData?.avatarAlt}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="channel-info flex-1 min-w-0">
            <div className="flex items-start justify-between gap-4 mb-3">
              <div className="flex-1 min-w-0">
                <h1 className="text-3xl font-heading font-semibold text-foreground mb-2 break-words">
                  {channelData?.name}
                </h1>
                <p className="text-base text-muted-foreground mb-3 line-clamp-2">
                  {channelData?.voiceDescription}
                </p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-4 mb-4">
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Icon name="Users" size={16} color="var(--color-muted-foreground)" />
                <span className="font-mono">{channelData?.subscriberCount?.toLocaleString('ru-RU')} подписчиков</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Icon name="Radio" size={16} color="var(--color-muted-foreground)" />
                <span className="font-mono">{channelData?.broadcastCount} эфиров</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
                <span className="font-mono">{channelData?.totalHours} часов контента</span>
              </div>
            </div>

            <div className="flex flex-wrap gap-3">
              <Button
                variant={isSubscribed ? "outline" : "default"}
                size="default"
                iconName={isSubscribed ? "Check" : "Plus"}
                iconPosition="left"
                onClick={onSubscribe}
              >
                {isSubscribed ? 'Вы подписаны' : 'Подписаться'}
              </Button>

              {isSubscribed && (
                <Button
                  variant="ghost"
                  size="default"
                  iconName="Bell"
                  iconPosition="left"
                  onClick={onNotificationToggle}
                >
                  Уведомления
                </Button>
              )}

              <Button
                variant="ghost"
                size="default"
                iconName="Share2"
                iconPosition="left"
              >
                Поделиться
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChannelHeader;